import type { IssueId } from '@atlassian/jira-platform-board-kit/src/common/types.tsx';

export const InlineEditingEventTypes = {
	INLINE_EDITING_BOARD_PARENT_UPDATED: 'INLINE_EDITING_BOARD_PARENT_UPDATED',
	INLINE_EDITING_BOARD_REALTIME_UPDATED: 'INLINE_EDITING_BOARD_REALTIME_UPDATED',
} as const;

export type InlineEditingPubSubEvent =
	(typeof InlineEditingEventTypes)[keyof typeof InlineEditingEventTypes];

type InlineEditingParentUpdatedPayload = {
	issueId: IssueId;
	parentId: number;
};

export type InlineEditingRealtimeIssueUpdatedPayload = {
	issueId: IssueId;
};

export type InlineEditingPubSubPayload =
	| InlineEditingParentUpdatedPayload
	| InlineEditingRealtimeIssueUpdatedPayload;

export type InlineEditingSubscriber = (
	type: InlineEditingPubSubEvent,
	payload: InlineEditingPubSubPayload,
) => void;
